import { useEffect, useState } from 'react';
import api from '../lib/api';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { ApprovalQueue } from '../components/duti/ApprovalQueue';
import { ActivityLog } from '../components/duti/ActivityLog';
import { DutiSettingsPanel } from '../components/duti/DutiSettingsPanel';
import { MyRequests } from '../components/duti/MyRequests';
import { RestockBriefing } from '../components/duti/RestockBriefing';
import { ShortageForecast } from '../components/duti/ShortageForecast';
import { DUTI_AI_AVATAR } from '../lib/brand';

export default function DutiAIPage() {
  const [settings, setSettings] = useState(null);
  const [queueKey, setQueueKey] = useState(0);
  useEffect(() => { api.get('/duti/settings').then(({ data }) => setSettings(data)).catch(() => {}); }, []);
  const owner = settings?.can_manage;
  const enabled = settings ? Object.values(settings.abilities).filter(Boolean).length : 0;

  return (
    <div className="space-y-8 p-1" data-testid="duti-ai-page">
      <header className="flex flex-wrap items-end justify-between gap-4">
        <div className="flex items-center gap-4">
          <img src={DUTI_AI_AVATAR} alt="Duti AI" className="h-12 w-12 rounded-full shadow-sm ring-1 ring-primary/20" data-testid="duti-ai-page-avatar" />
          <div>
            <h1 className="text-3xl font-semibold tracking-tight">Duti AI</h1>
            <p className="text-sm text-muted-foreground">Your pharmacy staff agent — it drafts, you decide.</p>
          </div>
        </div>
        {settings && (
          <p className="text-sm text-muted-foreground" data-testid="duti-status-line">
            {settings.paused ? 'Hands-on abilities paused' : `${enabled} of ${settings.abilities_meta.length} hands-on abilities on`}
          </p>
        )}
      </header>

      <Tabs defaultValue="queue">
        <TabsList className="max-w-full overflow-x-auto justify-start">
          <TabsTrigger value="queue" data-testid="duti-tab-queue">Approval queue</TabsTrigger>
          <TabsTrigger value="mine" data-testid="duti-tab-mine">My requests</TabsTrigger>
          {owner && <TabsTrigger value="activity" data-testid="duti-tab-activity">Activity log</TabsTrigger>}
          <TabsTrigger value="settings" data-testid="duti-tab-settings">Abilities</TabsTrigger>
        </TabsList>
        <TabsContent value="queue" className="pt-6 space-y-8">
          <RestockBriefing owner={owner} onDrafted={() => setQueueKey((k) => k + 1)} />
          <ShortageForecast onDrafted={() => setQueueKey((k) => k + 1)} />
          <ApprovalQueue key={queueKey} />
        </TabsContent>
        <TabsContent value="mine" className="pt-6"><MyRequests /></TabsContent>
        {owner && <TabsContent value="activity" className="pt-6"><ActivityLog /></TabsContent>}
        <TabsContent value="settings" className="pt-6">
          {settings && <DutiSettingsPanel settings={settings} onChange={setSettings} />}
        </TabsContent>
      </Tabs>
    </div>
  );
}
